// Main menu items for header navigation (shared across portals)
export interface MainMenuItem {
  label: string;
  route: string;
  subitems?: MainMenuItem[];
}
// Note: do NOT import environment here (library consumer may resolve env differently).
// Accept an optional `apiBaseUrl` so callers can pass the portal environment value.
export function getMainMenuItems(apiBaseUrl?: string): MainMenuItem[] {
  const api = String(apiBaseUrl || '').toLowerCase();

  // VAT header when running against VAT API
  if (api.includes('8092') || api.includes('vat-return-node') || api.includes('vat-node') || api.includes('vat.onetaxbahamas') || api.includes('8096')) {
    return [
      { label: 'Dashboard', route: '/dashboard' },
      {
        label: 'VAT Registration', route: '/vat/vat-registration/new',
        // subitems: [
        //   { label: 'New Registration', route: '/vat/vat-registration/new' },
        //   { label: 'View/Modify Registration Details', route: '/vat/vat-registration/modify' },
        //   { label: 'Track Application', route: '/vat/vat-registration/track' }
        // ],
      },
      { label: 'Returns', route: '/vat/returns' },
      {
        label: 'Payments & Refunds',
        route: '/vat/payments-and-funds',
        subitems: [
          { label: 'Payment Declaration', route: '/vat/payments-and-funds' },
        ],
      },
    ];
  }

  // Default (DMTT) header
  return [
    { label: 'Dashboard', route: '/dashboard' },
    {
      label: 'DMTT Registration',
      route: '/dmtt/dmtt-registration',
      subitems: [
        { label: 'New Registration', route: '/dmtt/dmtt-registration/new' },
        { label: 'View/Modify Registration Details', route: '/dmtt/dmtt-registration/modify' },
        { label: 'Track Application', route: '/dmtt/dmtt-registration/track' }
      ],
    },
    { label: 'Returns', route: '/returns' },
    {
      label: 'Payments & Refunds',
      route: '/dmtt/payments-and-funds',
      subitems: [
        { label: 'Payment Declaration', route: '/dmtt/payments-and-funds' },
      ],
    },
  ];
}
// Shared menu items for sidebars across portals
// Usage: import { getSideMenuItems } from './side-menu-items';

export interface SideMenuItem {
  label: string;
  route: string;
  icon: string;
  subitems?: SideMenuItem[];
}

export function getSideMenuItems(apiBaseUrl: string): SideMenuItem[] {
  // VAT Portal menu items
  if (apiBaseUrl.includes('8092') || apiBaseUrl.includes('vat-node') || apiBaseUrl.includes('vat.onetaxbahamas')) {
    return [
      { label: 'New Registration or Reactivation', route: '/vat/vat-registration/new', icon: 'post_add' },
      { label: 'Modify Registration Details', route: '/vat/vat-registration/modify', icon: 'edit' },
      { label: 'Cancellation', route: '/vat/vat-registration/cancel', icon: 'cancel' },
      { label: 'Track Application', route: '/vat/vat-registration/track', icon: 'history' },
      // { label: 'Returns', route: '/vat/returns', icon: 'assignment_return' },
    ];
  }
  // DMTT Returns menu items
  else if (apiBaseUrl.includes('8089') || apiBaseUrl.includes('dmtt-return-node')) {
    return [
      { label: 'DMTT Returns', route: '/returns', icon: 'dashboard_customize' },
    ];
  }
 // VAT Returns menu items
  else if (apiBaseUrl.includes('8096') || apiBaseUrl.includes('vat-return-node') || apiBaseUrl.includes('vat-node') || apiBaseUrl.includes('vat.onetaxbahamas')) {
    return [
      { label: 'VAT Returns', route: '/returns', icon: 'dashboard_customize' },
      { label: 'Track Application', route: '/track-application', icon: 'history' }
    ];
  }

  // Default fallback
  else {
    return [
      { label: 'DMTT Returns', route: '/returns', icon: 'dashboard_customize' },
    ];
  }
}
